module.exports = __webpack_public_path__ + "img/sales.5f8cecd9.svg";